export default __webpack_public_path__ + "static/media/dot_extended-repair-selected.6072c1bb.svg";